import dayjs from 'dayjs';
import 'dayjs/locale/lv';

// Custom month names for printing
const monthsShort = ['jan', 'feb', 'mar', 'apr', 'mai', 'jūn', 'jūl', 'aug', 'sep', 'okt', 'nov', 'dec'];
const monthsWhen = ['janvārī', 'februārī', 'martā', 'aprīlī', 'maijā', 'jūnijā', 'jūlijā', 'augustā', 'septembrī', 'oktobrī', 'novembrī', 'decembrī'];

// Extend dayjs with localized formats
const DayJs = dayjs.extend(require('dayjs/plugin/localizedFormat'));

// Extend with plugins
DayJs.extend(require('dayjs/plugin/relativeTime'));
DayJs.extend(require('dayjs/plugin/customParseFormat'));
DayJs.extend(require('dayjs/plugin/updateLocale'));
DayJs.extend(require('dayjs/plugin/calendar'));

// Set latvian localization
// TODO: Should change based on user's language
DayJs.locale('lv');

// Update latvian localization
DayJs.updateLocale('lv', {
	monthsShort: (instance, format) => {
		if (/YYYY\. \[gada\] D\. MMM/i.test(format)) {
			return monthsWhen[instance.month()];
		}
		return monthsShort[instance.month()];
	},
	formats: {
		LT: 'HH:mm',
		LTS: 'HH:mm:ss',
		L: 'DD.MM.YYYY.',
		LL: 'YYYY. [gada] D. MMMM',
		LLL: 'YYYY. [gada] D. MMMM, HH:mm',
		LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
		ll: 'YYYY. [gada] D. MMM'
	}
});

const CONVERSATION_CALENDAR = {
	lastDay: '[Vakar] LT',
	sameDay: 'LT',
	nextDay: '[Rīt] LT',
	lastWeek: 'D. MMM, YYYY',
	sameElse: 'D. MMM, YYYY'
};

const CHAT_CALENDAR = {
	lastDay: '[Vakar]',
	sameDay: '[Šodien]',
	nextDay: '[Rīt]',
	lastWeek: 'dddd',
	sameElse: 'D. MMM, YYYY'
};

export {
	CONVERSATION_CALENDAR,
	CHAT_CALENDAR
};

export default DayJs;
